import { ActionIcon, Box, Tooltip } from "@mantine/core";
import {
  IconCheck,
  IconPlayerPause,
  IconPlayerPlay,
  IconX,
} from "@tabler/icons-react";

const RecordControls = ({
  cancelRecording,
  isPaused,
  resumeRecording,
  pauseRecording,
  stopRecording,
}: {
  cancelRecording: () => void;
  isPaused: boolean;
  resumeRecording: () => void;
  pauseRecording: () => void;
  stopRecording: ({
    isUploadRecord,
    openEditRecordingNameModal,
  }: {
    isUploadRecord?: boolean;
    openEditRecordingNameModal?: boolean;
  }) => void;
}) => {
  return (
    <Box
      bg={"#E6E6E6"}
      h={82}
      mt={34}
      w={335}
      style={{
        display: "flex",
        borderRadius: "24px",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0px 4px 4px 0px #00000033",
      }}
    >
      <Tooltip withArrow label="Delete">
        <ActionIcon
          onClick={cancelRecording}
          w={53}
          h={56}
          radius={"10"}
          bg={"white"}
          c={"#B70000"}
          style={{
            boxShadow: "0px 4px 4px 0px #0000001A",
          }}
        >
          <IconX size={30} />
        </ActionIcon>
      </Tooltip>
      <Box
        bg={"#E6E6E6"}
        h={108}
        w={110}
        mx={28}
        style={{
          display: "flex",
          borderRadius: "50%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Tooltip withArrow label={isPaused ? "Continue" : "Pause"}>
          <ActionIcon
            w={88}
            h={90}
            radius={"50%"}
            bg={"white"}
            c={"#000"}
            onClick={isPaused ? resumeRecording : pauseRecording}
          >
            {isPaused ? (
              <IconPlayerPlay
                style={{ width: "60%", height: "60%" }}
                stroke={1.5}
              />
            ) : (
              <IconPlayerPause
                style={{ width: "60%", height: "60%" }}
                stroke={1.5}
              />
            )}
          </ActionIcon>
        </Tooltip>
      </Box>
      <Tooltip withArrow label="Done">
        <ActionIcon
          w={53}
          h={56}
          radius={"10"}
          bg={"white"}
          c={"#003554"}
          style={{
            boxShadow: "0px 4px 4px 0px #0000001A",
          }}
          onClick={() => {
            stopRecording({
              isUploadRecord: true,
              openEditRecordingNameModal: true,
            });
          }}
        >
          <IconCheck size={30} color="#003554" />
        </ActionIcon>
      </Tooltip>
    </Box>
  );
};

export default RecordControls;
